import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import React, { Component } from 'react'
import { SimpleConfigContext } from '../../../Context/Portal/SimpleConfigContext';
import { getNode, updateNode } from '../../Helpers/Nodes';
import General from './General';
import MenuItems from './MenuItems';
import { getCompressedJson } from '../../../API/Export/ExportApi';
import { publishApplication, getPortalJsonForRuntimeInlineEdit, publishPortalJsonToRuntime } from '../../Helpers/Launch';
import Scrollable from '../../Shared/Edit/Scrollable';
import { callApiWithAuthorization } from '../../../API/CallApi';
import InnerLoader from "../../Shared/Loader/InnerLoader"
import { OverlayLoader } from '../../Shared/Loader/OverlayLoader';
import { getEntitiesShownInMenuItems } from '../../Helpers/Portal/Portal';
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { getPortal, reorderItems, updateItem, updatePortal, updatePortalTargetPage } from '../../../API/Portal/Portal';
import { withTranslation } from 'react-i18next';
import { getProject, updateProject, updateProjectInstance } from '../../../API/Project/project';

class SimpleConfig extends Component {
    static contextType = SimpleConfigContext;

    state = {
        error: "",
        publishError: "",
    };

    async componentDidMount() {
        try {
            const { portalId } = this.props;
            const [
                portal, portalTargetPage, menuItems
            ] = await Promise.all([
                getPortal(portalId),
                this.getPortalTargetPage(),
                this.getMenuItems()
            ])
            this.context.setPortal(portal);
            this.context.setPortalTarget(portalTargetPage)
            this.context.setEntities(menuItems);
            this.context.menuItemsDataLoaded();
            this.context.setLoading(false);
            if (this.props.mutators && this.props.mutators.setFormSaveFunction) {
                this.props.mutators.setFormSaveFunction(() => this.save);
            }
            // this.props.i18n.changeLanguage("ar");
        } catch (error) {
            this.setState({ error: error.message })
        }
    }

    componentDidUpdate(prevProps) {
        const hasChanges = !this.shouldSaveBeDisabled();
        if (
            this.props.mutators && this.props.mutators.setFormsWithChanges &&
            this.props.hasChanges !== hasChanges
        ) {
            debugger
            this.props.mutators.setFormsWithChanges((prevValue) => ({
                ...prevValue,
                menuItemForm: hasChanges
            }));
        }
    }

    async getPortalTargetPage() {
        const { t, portalId } = this.props;
        const request = await callApiWithAuthorization("/api/v0/portal/" + portalId + "/getPortalAndLandingPage")
        const result = await request.json();
        if (result.message === "Portal not found") {
            throw new Error(result.message);
        }
        const {
            landingPageRelationId,
            landingPage: page
        } = result;
        return { page, landingPageRelationId };
    }

    async getMenuItems() {
        const { portalId } = this.props;
        const [entities, error] = await getEntitiesShownInMenuItems(portalId)
        if (error) {
            console.error(error);
            return;
        }
        for (const entity of entities) {
            if (entity.recentRecordAttributes.length === 0) {
                entity.recentRecordAttributes = [{}, {}];
            }
        }
        return entities;
    }

    render() {
        const { loading, selectedTabIndex, saving, publishing } = this.context;
        const { t } = this.props;

        if (loading) {
            return (
                <div className='d-flex flex-column h-100'>
                    <div className='row' style={{ marginTop: 10 }}>
                        <div className='col-10'><div className='sk'></div></div>
                        <div className='col-2'><div className='sk'></div></div>
                    </div>
                    <div className='flex-grow-1 sk' style={{ marginTop: 25 }}>
                    </div>
                </div>
            )
        }

        if (this.state.error) {
            return (
                <div className='d-flex flex-column h-100'>
                    <div className='flex-grow-1'>
                        <div className='d-flex flex-column align-items-center justify-content-center h-100'>
                            <div className='text-center'>
                                <h3 className='text-danger'>{t("errors.something_went_wrong")}</h3>
                                <p className='text-danger'>{this.state.error}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return (

            <div className='d-flex flex-column h-100 line'>
                {(saving || publishing) && (
                    <OverlayLoader />
                )}
                {this.props.accessedFromRuntime && (
                    <>

                        <div className="row w-100 align-items-center border-bottom">
                            <div className="pb-2 col">
                                <span className={`d-block py-2 px-3 d-flex align-items-center`}>
                                    <span>
                                        {t("header.title")}
                                    </span>
                                </span>
                            </div>
                            {this.state.publishError &&
                                <div className='col'>{this.state.publishError}</div>
                            }
                            {this.context.saveAndPublishCompleted && (
                                <div className="d-inline-block col">
                                    <span
                                        className={
                                            (this.context.publishSuccessfull === true
                                                ? "text-success"
                                                : "text-danger")
                                        }
                                    >
                                        {this.context.publishMessage}
                                    </span>
                                </div>
                            )}
                            <div className='col-4 pe-0 pl-20 text-end'>
                                {publishing && (
                                    <img
                                        className='me-2'
                                        width="30px"
                                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/SpinLoader.gif`}
                                    />
                                )}
                                <button
                                    disabled={publishing || saving}
                                    className="btn btn-outline-primary mb-1"
                                    onClick={this.publishApp}
                                >
                                    <i className="mx-1 fas fa-rocket"></i>
                                    {t("header.buttons.update_menu")}
                                </button></div>
                        </div>

                    </>
                )}

                <div className="d-flex align-items-center w-100 ">
                    <div className="pe-2 w-100 d-flex align-items-center justify-content-between">
                        <div className={`header d-flex`}>
                            <span
                                className={`d-block p-3 pe-2 d-flex align-items-center `}
                            >
                                <div className='ps-1'>
                                    {this.props.accessedFromRuntime ===
                                        false && (
                                            <>
                                                <span className="page-header">
                                                    {t("secondary_header.title")}
                                                </span>
                                                <h6 className="mt-2 font-weight-light">
                                                    <span className='fontUrl'>
                                                        {t("secondary_header.description")}
                                                    </span>
                                                </h6>
                                            </>
                                        )}

                                </div>
                            </span>
                        </div>

                        <div className="d-flex align-items-center mb-1">
                            {this.checkIfAllEntitiesAreChecked() === false && (
                                <div className="d-inline-block pe-2">
                                    <span className="text-danger">
                                        {t("errors.one_item_must_be_selected")}
                                    </span>
                                </div>
                            )}
                            {
                                saving && (
                                    this.props.accessedFromRuntime === false &&
                                    <div className="me-2">
                                        <InnerLoader borderColor="green" />
                                    </div>
                                )
                            }
                            <Menu
                                onSelect={(e) => e.item.data()}
                                className="no-dropdown-in-menu three-dots"
                            >
                                <MenuItem
                                    cssClass="btn btn-secondary px-1"
                                    icon="more-horizontal g-0 m-0 ps-2"
                                    data={() => { }}
                                >
                                    <MenuItem
                                        data={this.revert}
                                        icon="undo"
                                        disabled={this.shouldSaveBeDisabled()}
                                        text={t("header.buttons.revert_changes")}
                                    ></MenuItem>
                                </MenuItem>
                            </Menu>
                        </div>
                    </div>
                </div>

                <Scrollable>
                    <div className='mt-8 ml-9'>
                        <TabStrip
                            animation={false}
                            className="splitter-tab edit1 mg-10"
                            selected={selectedTabIndex}
                            onSelect={this.context.setSelectedTab}
                        >
                            <TabStripTab title={t("tabs.general")}>
                                <General useSuspense={false} />
                            </TabStripTab>
                            {(!this.context.portal?.isMobilePortal || this.props.project?.developerMode) && (
                                <TabStripTab title={t("tabs.menu_items")}>
                                    <MenuItems
                                        useSuspense={false}
                                        subscription={this.props.subscription}
                                        project={this.props.project}
                                        projectId={this.props.projectId}
                                        portalId={this.props.portalId}
                                    />
                                </TabStripTab>
                            )}
                        </TabStrip>
                    </div>
                </Scrollable>

            </div>
        );
    }

    shouldSaveBeDisabled = () => {
        const { saving, publishing } = this.context;
        if (saving || publishing) {
            return true
        }
        const allEntitiesAreUnchecked = this.checkIfAllEntitiesAreChecked() === false;
        if (allEntitiesAreUnchecked) {
            return true;
        }
        const orientationChanged = this.checkIfNavigationBarOrientationChanged();
        if (orientationChanged) {
            return false;
        }
        const dashboardChanged = this.checkIfDashboardChanged();
        if (dashboardChanged) {
            return false
        }
        const reportingChanged = this.checkIfReportingChanged();
        if (reportingChanged) {
            return false
        }
        const isWorkflowEnabledChanged = this.checkIfIsWorkflowEnabledChanged();
        if (isWorkflowEnabledChanged) {
            return false
        }
        const historyReportingChanged = this.checkIfHistoryReportingChanged();
        if (historyReportingChanged) {
            return false
        }
        const commentReportingChanged = this.checkIfCommentReportingChanged();
        if (commentReportingChanged) {
            return false
        }
        const anyEntityDetailChanged = this.checkIfAnyEntitiesDetailChanged();
        if (anyEntityDetailChanged) {
            return false;
        }
        return true;
    };

    checkIfNavigationBarOrientationChanged = () => {
        return (
            this.context.defaultNavigationBarOrientation !==
            this.context.navigationBarOrientation
        );
    };

    checkIfDashboardChanged = () => {
        return (
            this.context.defaultEnableDashboard !==
            this.context.enableDashboard
        );
    };

    checkIfReportingChanged = () => {
        return (
            this.context.defaultEnableReporting !==
            this.context.enableReporting
        );
    };

    checkIfIsWorkflowEnabledChanged = () => {
        return (
            this.context.defaultIsWorkflowEnabled !==
            this.context.isWorkflowEnabled
        );
    };

    checkIfHistoryReportingChanged = () => {
        return (
            this.context.defaultEnableHistoryReporting !==
            this.context.enableHistoryReporting
        );
    };

    checkIfCommentReportingChanged = () => {
        return (
            this.context.defaultEnableCommentReporting !==
            this.context.enableCommentReporting
        );
    };

    shouldForceHistoryAndCommentReporting = () => {
        return (
            this.context.portal?.enableHistoryReporting === undefined ||
            this.context.portal?.enableHistoryReporting === null ||
            this.context.portal?.enableCommentReporting === undefined ||
            this.context.portal?.enableCommentReporting === null
        );
    };

    checkIfAnyEntitiesDetailChanged = () => {
        return this.context.entities.findIndex(this.ofChangedEntity) > -1;
    };

    checkIfAllEntitiesAreChecked = () => {
        if (this.context.entities.length === 0) {
            return true;
        }
        return this.context.entities.findIndex(entity => entity.show) > -1;
    }

    ofChangedEntity(entity) {
        return entity.isChanged;
    }

    shouldChangeLandingPage = () => {
        if (this.context.entities.length === 0) {
            return false;
        }
        const currentFirstItemTargetPage = this.context.entities[0].targetPage;
        if (
            currentFirstItemTargetPage === undefined ||
            currentFirstItemTargetPage === null
        ) {
            return true;
        }
        if (currentFirstItemTargetPage._id !== this.context.portalTarget.page._id) {
            return true;
        }
        const firstItemShow = this.context.entities[0].show;
        if (firstItemShow === false) {
            return true;
        }
        return false;
    };

    revert = async () => {
        this.context.revertChanges()
    }

    save = async () => {
        this.context.showSaving();
        let relationId = this.context.portalTarget.landingPageRelationId;
        if (
            this.checkIfNavigationBarOrientationChanged() ||
            this.checkIfDashboardChanged() ||
            this.checkIfReportingChanged() ||
            this.checkIfIsWorkflowEnabledChanged() ||
            this.checkIfHistoryReportingChanged() ||
            this.checkIfCommentReportingChanged() ||
            this.shouldForceHistoryAndCommentReporting()
        ) {
            const { portal, navigationBarOrientation, enableDashboard, enableReporting, isWorkflowEnabled, enableHistoryReporting, enableCommentReporting } = this.context;
            await updatePortal(portal._id, {
                navigationBarOrientation: typeof navigationBarOrientation === "string" ? navigationBarOrientation : navigationBarOrientation.value,
                enableDashboard,
                enableReporting,
                isWorkflowEnabled,
                enableHistoryReporting,
                enableCommentReporting
            });
        }
        if (this.checkIfAnyEntitiesDetailChanged()) {
            await this.saveEntitiesDetails();
        }
        if (this.shouldChangeLandingPage()) {
            const firstShownEntity = this.context.entities.find(entity => entity.show);
            if (firstShownEntity && firstShownEntity.targetPage && firstShownEntity.targetPage._id) {
                await updatePortalTargetPage(this.props.portalId, firstShownEntity.targetPage._id);
            } else {
                await updatePortalTargetPage(this.props.portalId, "");
            }
        }
        const newState = {
            defaultNavigationBarOrientation: this.context.navigationBarOrientation,
            defaultEnableDashboard: this.context.enableDashboard,
            defaultEnableReporting: this.context.enableReporting,
            defaultEnableHistoryReporting: this.context.enableHistoryReporting,
            defaultEnableCommentReporting: this.context.enableCommentReporting,
            entities: this.context.entities.map((entity, index) => ({
                ...entity,
                defaultLabel: entity.label,
                defaultShow: entity.show,
                defaultIndex: index,
                defaultRecentRecordAttributes: [
                    ...entity.recentRecordAttributes,
                ],
                currentIndex: index,
                isChanged: false,
            })),
            portalTarget: {
                page: { id: "" },
                landingPageRelationId: relationId
            },
            saving: false
        };
        if (this.context.entities.length > 0 && this.context.entities[0].targetPage) {
            newState.portalTarget.page.id = this.context.entities[0].targetPage.id;
        }
        this.context.updateDefaultValuesToCurrentValue(newState);
    };

    saveEntitiesDetails = async () => {
        const { entities } = this.context;
        const newItemsData = [];
        for (const entity of entities) {
            const { allItemProperties } = entity;
            if (entity.isChanged) {
                // await updateItem(this.props.portalId, entity.menuItemId, {
                //     label: entity.label,
                //     show: entity.show,
                //     order: entity.order,
                // });
                const newItemProperties = {
                    ...allItemProperties,
                    label: entity.label.trim(),
                    show: entity.show,
                    order: entity.order,
                    languages: entity.languages,
                }
                if (newItemProperties.children) {
                    const recentRecord = newItemProperties.children.find(item => item.id === entity.recentRecordId);
                    recentRecord.attributes = entity.recentRecordAttributes ? (
                        entity.recentRecordAttributes.filter(attr => !!attr).map(({ _id }) => _id)
                    ) : [];
                }
                newItemsData.push(newItemProperties);
            } else {
                newItemsData.push(allItemProperties);
            }
        };
        reorderItems(this.props.portalId, { items: newItemsData });
    };

    publishApp = async () => {
        const saveDisabled = this.shouldSaveBeDisabled();
        if (saveDisabled === false) {
            await this.save();
        }
        this.context.showPublishing();
        const project = await getProject(this.props.projectId);
        const instances = project.instances.filter(instance => instance.Published === true);
        const instance = instances[0];
        let publishResponse;
        if (project.hasSchemaChanges && project.hasSchemaChanges === true) {
            publishResponse = await this.doFullGeneration(instance);
        } else {
            publishResponse = await this.doIncrementalPublish(instance);
        }
        const { status, message } = publishResponse;
        this.context.showAfterPublishMessage(status, message);
        if (status === "Success") {
            // await updateNode("Project", this.props.projectId, { "hasSchemaChanges": false });
            await updateProjectInstance(this.props.projectId, instance._id, { isDbChanged: false })
            await updateProject(this.props.projectId, { hasSchemaChanges: false });
            const runtimeURL = process.env.REACT_APP_RUNTIME_URL;
            window.parent.postMessage(
                JSON.stringify({
                    designerStatus: "Success",
                }),
                runtimeURL
            );
        }
    };

    doIncrementalPublish = async (instance) => {
        try {
            const portalJson = await getPortalJsonForRuntimeInlineEdit(
                this.props.organisationId,
                this.props.projectId,
                this.props.portalId,
                this.props.instanceId,
            );
            const runtimeResponse = await publishPortalJsonToRuntime(
                instance._id, this.props.portalId, portalJson.Portals[0]
            );
            return runtimeResponse;
        } catch (e) {
            return { message: e.message };
        }
    }

    doFullGeneration = async (instance) => {
        try {
            const {
                organisationId,
                projectId,
                publisherId,
                instanceId,
                msalContext,
            } = this.props;
            const compressedJson = await getCompressedJson(
                projectId,
                organisationId,
                publisherId,
                instanceId,
                false,
                false
            );
            const publishResponse = await publishApplication(
                msalContext,
                instance,
                compressedJson,
                false
            );
            return publishResponse;
        } catch (e) {
            return { message: e.message };
        }
    }
}

export default withTranslation([
    "portal_simple_config/simple_config",
    "portal_simple_config/general",
    "portal_simple_config/menu_items"
])(SimpleConfig);